const popupTopTypes = {
	success: 'success' as const,
	error: 'error' as const
} as const

export default popupTopTypes
